import type { WorkBook } from 'xlsx';

import { classifySupersededLocations } from './classifySupersededLocations';
import {
  classifyRdAccessRow,
  scanRdStockWorkbook,
  type RdStockAnalysisBuckets,
  type RdStockSheetRow,
} from './rdStockAnalysis';

export const SUPERSEDED_WITH_STOCK_HEADERS = [
  'PRODUCT ACCESS COMPANY',
  'PRODUCT ACCESS LOCATION',
  'STOCK ACCESS COMPANY',
  'STOCK ACCESS DIVISION',
  'STOCK ACCESS LOCATION',
  'PRODUCT NUMBER',
  'STOCK RECORD ID',
] as const;

const ITEM_COLUMN = 'PRODUCT ACCESS LOCATION';

export type SupersededWithStockAnalysis = RdStockAnalysisBuckets;

function classifyStocksVRow(input: RdStockSheetRow) {
  const itemMasterLocation = input.cell(ITEM_COLUMN);
  return classifyRdAccessRow({
    input,
    match: classifySupersededLocations({
      stockLetter: input.cell('STOCK ACCESS LOCATION'),
      itemMasterLetter: itemMasterLocation,
    }),
    itemColumn: ITEM_COLUMN,
    itemMasterLocation,
  });
}

/**
 * STOCKS_V: Product Access Location ↔ Stock Access Location through the
 * Vera map. Mismatches and unpaired I are flagged. Same-DC pairs are
 * listed separately. Letter equality is never a match (GEN-2668).
 */
export function analyzeSupersededWithStock(
  workbook: WorkBook,
  fileName: string,
): SupersededWithStockAnalysis | null {
  return scanRdStockWorkbook({
    workbook,
    fileName,
    headers: SUPERSEDED_WITH_STOCK_HEADERS,
    classifyRow: classifyStocksVRow,
  });
}
